import React, { PropTypes } from 'react';
import { Button } from 'bootstrap';
import classnames from 'classnames';

const PrompterRowHeader = ({
  isEditing,
  onSave,
  onCancel,
  index,
  actionBarStyle,
}) => {
  const actionNodes =
    isEditing && onSave && onCancel ? (
      <div
        style={actionBarStyle}
        className="featured-fullscreen-header-actions"
        data-testid={`featured-fullscreen-header-actions-${index}`}
      >
        <Button className="featured-editor-header-save-btn" onClick={onSave}>
          Save
        </Button>
        <Button
          className="featured-editor-header-cancel-btn"
          id="btn-cancel"
          onMouseDown={onCancel}
        >
          Cancel
        </Button>
      </div>
    ) : null;

  return (
    <div
      className={classnames('featured-header featured-fullscreen-header', {
        isEditing,
      })}
    >
      {actionNodes}
    </div>
  );
};

PrompterRowHeader.propTypes = {
  isEditing: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  index: PropTypes.number,
  actionBarStyle: PropTypes.object,
};

export default PrompterRowHeader;
